/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrderDiscount,
    OrderDiscountFromJSON,
    OrderDiscountFromJSONTyped,
    OrderDiscountToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRestaurantsPromosResponse
 */
export interface SearchRestaurantsPromosResponse {
    /**
     * 
     * @type {Array<OrderDiscount>}
     * @memberof SearchRestaurantsPromosResponse
     */
    promos: Array<OrderDiscount>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchRestaurantsPromosResponse
     */
    restaurantsInProximity: Array<string>;
}

export function SearchRestaurantsPromosResponseFromJSON(json: any): SearchRestaurantsPromosResponse {
    return SearchRestaurantsPromosResponseFromJSONTyped(json, false);
}

export function SearchRestaurantsPromosResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRestaurantsPromosResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'promos': ((json['promos'] as Array<any>).map(OrderDiscountFromJSON)),
        'restaurantsInProximity': json['restaurantsInProximity'],
    };
}

export function SearchRestaurantsPromosResponseToJSON(value?: SearchRestaurantsPromosResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promos': ((value.promos as Array<any>).map(OrderDiscountToJSON)),
        'restaurantsInProximity': value.restaurantsInProximity,
    };
}


